export const appVersion = () => {
    const v = import.meta.env.VITE_VERSION as string
    if (v) {
        const n = v.split('.')
        if (n.length > 3) return `${n[0]}.${n[1]}.${n[2]}`
    } else {
        return '0.0.0'
    }
    return v;
}

export const serviceVersion = () => {
    const v = import.meta.env.VITE_SERVICE_VERSION as string
    if (v) {
        return v;
    }
    throw new Error('VITE_SERVICE_VERSION is not defined')
}
